import React from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Paper, Select } from '@mui/material';
import CustomButtonsTable from 'js/components/TriiboComponents/Tables/CustomButtonsTable';
import { columnTablePartnerFilesList } from './model';

export const SectionFilterAndTable = ({
  componentReceiver,
  fileList,
  fileTypeList,
  type,
  setType,
  status,
  setStatus,
}) => {
  function breakStringEvery50Chars(str) {
    if (!str) return '';

    const chunkSize = 50;
    let result = '';

    for (let i = 0; i < str.length; i += chunkSize) {
      result += str.slice(i, i + chunkSize) + '\n';
    }

    return result.trim(); // remove a última quebra de linha
  }

  fileList = fileList.map((item, i) => {
    if (item.filename.length > 50) {
      item.filename = breakStringEvery50Chars(item.filename);
    }

    return item;
  });

  return (
    <Paper elevation={3} sx={{ maxWidth: '1250px', margin: '0 auto' }}>
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ marginTop: '0.5rem' }}
      >
        <Grid item>
          <FormControl fullWidth variant="outlined" sx={{ minWidth: '14rem' }}>
            <InputLabel id="file-type-filter">Filtrar por Tipo</InputLabel>
            <Select
              labelId="file-type-filter"
              value={type}
              onChange={(event) => setType(event.target.value)}
              label="Filtrar por Tipo"
            >
              <MenuItem value="">Todos</MenuItem>
              {fileTypeList.map((typeItem) => (
                <MenuItem key={typeItem.filePrefix} value={typeItem.filePrefix}>
                  {typeItem.filePrefix}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl fullWidth variant="outlined" sx={{ minWidth: '14rem' }}>
            <InputLabel id="file-status-filter">Filtrar por Status</InputLabel>
            <Select
              labelId="file-status-filter"
              value={status}
              onChange={(event) => setStatus(event.target.value)}
              label="Filtrar por Status"
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="ready">Aguardando</MenuItem>
              <MenuItem value="canceled">Cancelado</MenuItem>
              <MenuItem value="processed">Processado</MenuItem>
              <MenuItem value="processedError">Processado com erro</MenuItem>
              <MenuItem value="processing">Processando</MenuItem>
              <MenuItem value="registered">Registrado</MenuItem>
              <MenuItem value="validated">Validado</MenuItem>
              <MenuItem value="validationError">Validado com erro</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Grid container sx={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Grid item md={12} sx={{ margin: '0.5rem 0' }}>
          <CustomButtonsTable
            data={fileList}
            column={columnTablePartnerFilesList}
            perPage={10}
            componentReceiver={componentReceiver}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

